// plugins/vuetify.js

import Vue from 'vue';
import Vuetify from 'vuetify/lib'
import {
    ChevronDownIcon,
    XCircleIcon,
    SearchIcon,
    ArrowLeftIcon,
    ArrowRightIcon
} from 'vue-feather-icons'
import Checkbox from "../components/icons/Checkbox";
import CheckBoxMixed from "../components/icons/CheckBoxMixed";
import CheckboxChecked from "../components/icons/CheckboxChecked";
import Search from "../components/icons/Search";

const vuetify = new Vuetify({
    theme: { disable: true },
})

Vue.use(Vuetify)

const SAMMIO_ICONS = {

    checkboxOn: {
        component: CheckboxChecked,
    },
    checkboxOff: {
        component: Checkbox
    },
    checkboxIndeterminate: {
        component: CheckBoxMixed
    },
    subgroup: {
        component: ChevronDownIcon
    },
    clear: {
        component: XCircleIcon
    },
    search: {
        component: Search
    },
    next: {
        component: ArrowRightIcon
    },
    prev: {
        component: ArrowLeftIcon
    }

}

const opts = {
    icons: {
        values: SAMMIO_ICONS,
    }
}

export default new Vuetify(opts)
